import { render, staticRenderFns } from "./series_as.vue?vue&type=template&id=452bcb72&scoped=true&"
import script from "./series_as.vue?vue&type=script&lang=js&"
export * from "./series_as.vue?vue&type=script&lang=js&"
import style0 from "./series_as.vue?vue&type=style&index=0&id=452bcb72&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452bcb72",
  null
  
)

export default component.exports